import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../services/auth/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import SkeletonLoader from "../skeleton_loader";
interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <SkeletonLoader
                count={Math.floor(window.innerHeight / 40)}
                styles={{ height: 30, width: "100%" }}
              />
      </Box>
    );
  }

  if (isAuthenticated) {
    // Redirect authenticated users to dashboard or their intended destination
    const from = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute; 